module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-rounded-ESQGLQQ4.eot?9ac4298c39b2d61ec7b05d466835fc85";